/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2021 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";
import { purchaseorder } from './purchaseorder';

export class purchasedelivery extends purchaseorder {
  purchase_delivery_key: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "PURCHASE_DELIVERY";
  }
}
